module.exports = __webpack_public_path__ + "img/log-out.8a7b8ad1.svg";